import {
    Autocomplete,
    Box,
    Button,
    Divider,
    Grid,
    Icon,
    IconButton,
    InputAdornment,
    Paper,
    Popover,
    SwipeableDrawer,
    Typography,
    // Paper,
    autocompleteClasses,
} from '@mui/material';
import {
    CustomListBox2Styled,
    CustomListStyled,
    PageStyled,
    PassengerCardStyled,
    SearchBarWidgetDrawerStyled,
} from './index.styles';
import CustomInput, { CustomDatePicker, CustomSelect } from 'components/Input';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import * as yup from 'yup';
import {
    RemoveCircle,
    AddCircle,
    Search,
    Event,
    Person,
    LocationOn,
    Cancel,
    CalendarToday,
    NightlightRound,
    ChildCare,
    Hotel,
    Close,
} from '@mui/icons-material';
import moment from 'moment';
import 'moment/locale/tr';
import 'moment/locale/de';

// import { useDispatch, useSelector } from 'react-redux';
// import { setFlightInfo } from 'store/reducers/flightReducer';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
// import { FlightUrlGenerator, flightUrlInterface } from 'common/utils';
// import i18n from 'assets/i18n';
import { mediaBreakPoints, useMediaScreen } from 'common/theme/media';

import useHotelService from 'services/hotel/index.api';
import i18n from 'assets/i18n';
import { routesPaths } from 'config/routes';
import { convertToSlug, referenceTypeIDGenerator } from 'common/utils';
import { useDispatch, useSelector } from 'react-redux';
import { deleteHotelInfo, setHotelInfo } from 'store/reducers/hotelReducer';
// import { convertToSlug } from 'common/utils';
// import { routesPaths } from 'config/routes';

interface filterDataLocationInterface {
    // label: string;
    // code: string;
    // name: string;
    // city: string;
    // country: string;
    // countryCode: string;
    // id: string;
    label: string;
    referenceId: number | undefined;
    name: string;
    city: string;
    district: string;
    rating: number | undefined;
    country: string;
    referenceType: number | undefined;
    starNumber: number | undefined;
    type: string;
}
interface HotelSearchBarProps {
    showDetail?: boolean;
    data?: any;
    gtm?: string; // Google Tag Manager
    searchName?: string;
}

interface filterDataInterface {
    location: filterDataLocationInterface;
    checkInDate: string; // Giriş Tarihi
    checkOutDate: string; // Çıkış Tarihi
    adultGuest: number; // Yetişkin
    guestCount: number; // Total Yolcu
    childArr: number[]; // Çocuk
}

const HotelSearchBar = ({ gtm = 'undefined', showDetail = true, data, searchName }: HotelSearchBarProps) => {
    const media = useMediaScreen();
    const { t } = useTranslation();

    const isMobil = mediaBreakPoints.xltablet < media.width ? false : true;
    const [drawer, setDrawer] = useState('');
    // const containerRef = useRef(null);
    // const dataTemp: filterDataInterface = {
    //     location: {
    //         label: 'Çeşme Dream Ayasaranda Hotel,Çeşme,Türkiye',
    //         city: 'İzmir',
    //         district: 'Çeşme',
    //         name: 'Çeşme Dream Ayasaranda Hotel',
    //         rating: 100,
    //         referenceId: 8680,
    //         referenceType: 1,
    //         starNumber: 0,
    //         type: 'Butik Otel',
    //         country: 'Turkiye',
    //     },
    //     adultGuest: 2,
    //     checkInDate: '12-06-2024',
    //     checkOutDate: '12-07-2024',
    //     childGuest: 1,
    //     guestCount: 3,
    // };
    // data = dataTemp;

    const { search, searchCode, searchPopularCities } = useHotelService();

    const [focusIndex, setFocusIndex] = useState<number>(0);

    const handleFocusOutFunc = (data: any) => {
        let from = Boolean(data.location.label);

        let departureDate = Boolean(data.checkInDate);
        let returnDate = Boolean(data.checkOutDate);

        const tempArray = [
            { value: from, index: 1 },

            { value: departureDate, index: 2 },
            { value: returnDate, index: 3 },
        ];

        const result = tempArray.find((item: any) => item.value === false);

        result ? setFocusIndex(result.index) : setFocusIndex(0);
    };

    let oneDates = {
        value: '1',
        label: t(`hotel.guest.passengerText.underOne`),
    };
    let dates = Array.from({ length: 16 }, (_, index) => ({
        value: (index + 2).toString(),
        label: (index + 2).toString(),
    }));
    dates = [oneDates, ...dates];

    const [cities, setCities] = useState<any>([]);
    const [fromData, setFromData] = useState<any>([]);

    const [filterData, setFilterData] = useState<filterDataInterface>(
        data
            ? data
            : {
                  location: {
                      label: '',
                      referenceId: undefined,
                      name: '',
                      city: '',
                      district: '',
                      rating: undefined,
                      country: '',
                      referenceType: undefined,
                      starNumber: undefined,
                      type: '',
                  },
                  checkInDate: '',
                  checkOutDate: '',
                  adultGuest: 2,
                  childGuest: [],
                  guestCount: 2,
              }
    );

    const customLabelGenerator = (item: any) => {
        let customLabel: string = '';

        switch (item._source.ReferenceType) {
            // Otel
            case 1:
                customLabel =
                    i18n.language === 'tr'
                        ? item._source.Name + ', ' + item._source.District + ', ' + item._source.City
                        : item._source.NameEN + ', ' + item._source.DistrictEN + ', ' + item._source.CityEN;
                break;
            // İl
            case 2:
                customLabel = i18n.language === 'tr' ? item._source.Name : item._source.NameEN;
                break;
            // İlçe
            case 3:
                customLabel =
                    i18n.language === 'tr'
                        ? item._source.Name + ', ' + item._source.City
                        : item._source.NameEN + ', ' + item._source.CityEN;
                break;
            // Mahalle
            case 4:
                customLabel =
                    i18n.language === 'tr'
                        ? item._source.Name + ', ' + item._source.District + ', ' + item._source.City
                        : item._source.NameEN + ', ' + item._source.DistrictEN + ', ' + item._source.CityEN;
                break;
        }

        return customLabel;
    };

    //reduxdan son aranan oteller gelicek
    const currentFilterData = useSelector((state: any) => state.hotel.filterHistoryHotel);

    const dispatch = useDispatch();
    const getSearchCode = useCallback(
        async (text: string) => {
            if (text) {
                try {
                    const response = await searchCode(text);
                    let tempDataList: any = [];
                    const dataResponse = response.data.hits.hits ? response.data.hits.hits : [];

                    dataResponse.forEach((item: any) => {
                        const tempData = {
                            label: customLabelGenerator(item),
                            referenceId: item._source.ReferenceID,
                            name: i18n.language !== 'tr' ? item._source.NameEN : item._source.Name,
                            city: i18n.language !== 'tr' ? item._source.CityEN : item._source.City,
                            district: i18n.language !== 'tr' ? item._source.DistrictEN : item._source.District,
                            rating: item._source.Rating,
                            country: 'Türkiye',
                            referenceType: item._source.ReferenceType,
                            starNumber: item._source.StarNumber,
                            type: item._id,
                        };
                        tempDataList.push(tempData);
                    });

                    setFromData(tempDataList);
                    setFilterData({
                        ...data,
                        location: { ...tempDataList[0] },
                    });
                } catch (error) {
                    console.log(error);
                }
            } else {
                setFromData([]);
            }
        },
        [i18n.language]
    );

    const getSearch = useCallback(
        async (text: string) => {
            if (text.length >= 3) {
                try {
                    const response = await search(text);
                    let tempDataList: any = [];
                    const data = response.data.hits.hits ? response.data.hits.hits : [];

                    data.forEach((item: any) => {
                        const tempData = {
                            label: customLabelGenerator(item),
                            referenceId: item._source.ReferenceID,
                            name: i18n.language !== 'tr' ? item._source.NameEN : item._source.Name,
                            city: i18n.language !== 'tr' ? item._source.CityEN : item._source.City,
                            district: i18n.language !== 'tr' ? item._source.DistrictEN : item._source.District,
                            rating: item._source.Rating,
                            country: 'Türkiye',
                            referenceType: item._source.ReferenceType,
                            starNumber: item._source.StarNumber,
                            type: item._id,
                        };
                        tempDataList.push(tempData);
                    });
                    setFromData(tempDataList);
                } catch (error) {
                    console.log(error);
                }
            } else {
                setFromData([]);
            }
        },
        [i18n.language]
    );

    const sendSearch = () => {
        const urlTemp = window.location;
        let queryParams = new URLSearchParams(urlTemp.search);
        let currencyParam = queryParams.get('curr') ? `&curr=${queryParams.get('curr')}` : '';

        let parameter = '';
        const { checkInDate, checkOutDate, adultGuest, childArr, location } = filterData;

        // const tempData = {
        //     from: filterData.location.code + '-' + filterData.location.countryCode,

        //     startDate: filterData.checkInDate.replaceAll('-', ''),
        //     endDate: filterData.checkOutDate?.replaceAll('-', ''),
        //     count: `${filterData.adultGuest}-${filterData.childGuest}`,
        // } as flightUrlInterface;
        // window.location.href = FlightUrlGenerator(tempData);

        setTimeout(() => {
            dispatch(setHotelInfo(filterData));
        });

        setTimeout(() => {
            parameter = `checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&guest=${adultGuest}`;
            if (childArr.length > 0) {
                parameter += `&child=${childArr.join(',')}`;
            }
            parameter += currencyParam;
            if (location.referenceType === 1) {
                window.location.href = `${routesPaths[i18n.language].hotelDetails}/${convertToSlug(
                    location.name
                )}-${referenceTypeIDGenerator(location.referenceType)}${location.referenceId}?${parameter}`;
            } else {
                window.location.href = `${routesPaths[i18n.language].hotelList}/${convertToSlug(location.name)}-${t(
                    'seo.hotelList.urlHotel'
                )}-${referenceTypeIDGenerator(location.referenceType)}${location.referenceId}?${parameter}`;
            }
        });
    };

    //acılacak

    const CustomListBox = (props: any) => {
        return (
            <CustomListStyled>
                <Paper elevation={8} sx={{ mt: 1 }} {...props} />
            </CustomListStyled>
        );
    };

    // Not son aranan yerler componenti

    const CustomListBox2 = () => {
        return (
            <CustomListBox2Styled>
                <Paper elevation={8} sx={{ mt: 1 }}>
                    <div className="last-search-area">
                        {currentFilterData.filter((item: any) => {
                            return item.checkInDate >= moment(new Date()).format('YYYY-MM-DD');
                        }).length > 0 && (
                            <>
                                <div className="title">{t(`hotel.widgets.searchBar.lastSearchText`)}</div>
                                {currentFilterData
                                    .filter((item: any) => {
                                        return item.checkInDate >= moment(new Date()).format('YYYY-MM-DD');
                                    })
                                    .slice(0, isMobil ? 1 : 2)
                                    .map((item: any, index: any) => {
                                        return (
                                            <div className="cardArea" key={index}>
                                                <div className="closeButton">
                                                    <IconButton
                                                        onMouseDown={() => {
                                                            dispatch(deleteHotelInfo(index));
                                                        }}
                                                    >
                                                        <Close color="disabled" fontSize="small" />
                                                    </IconButton>
                                                </div>
                                                <div
                                                    className="card"
                                                    key={index}
                                                    onMouseDown={() => {
                                                        formik.setErrors({});
                                                        formik.setTouched({});

                                                        formik.setFieldValue('location', item.location);

                                                        formik.setFieldValue('checkInDate', item.checkInDate);
                                                        formik.setFieldValue('checkOutDate', item.checkOutDate);

                                                        setFilterData(item);
                                                    }}
                                                >
                                                    <div className="cardContent">
                                                        <div className="leftCard">
                                                            <span>
                                                                {item.location.referenceType === 1 ? (
                                                                    <Hotel fontSize="small" color="primary" />
                                                                ) : (
                                                                    <LocationOn fontSize="small" color="primary" />
                                                                )}
                                                            </span>
                                                            {item.location.name}
                                                        </div>
                                                    </div>
                                                    <div className="cardInfo">
                                                        <div>
                                                            <Event className="event-icon" color="primary" />

                                                            {moment(item.checkInDate)
                                                                .locale(i18n.language)
                                                                .format('DD MMM YYYY dddd')}
                                                            {item.checkOutDate &&
                                                                ' - ' +
                                                                    moment(item.checkOutDate)
                                                                        .locale(i18n.language)
                                                                        .format('DD MMM YYYY dddd')}
                                                        </div>
                                                    </div>
                                                    <div className="cardInfo">
                                                        <div>
                                                            <Person
                                                                fontSize="small"
                                                                color="primary"
                                                                className="event-icon"
                                                            />
                                                            {item.adultGuest}{' '}
                                                            {t(`hotel.widgets.searchBar.passengerText.ADT`)}
                                                            {item.childArr.length > 0
                                                                ? ', ' +
                                                                  item.childArr.length +
                                                                  ' ' +
                                                                  t(`hotel.widgets.searchBar.passengerText.CHD`)
                                                                : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </>
                        )}
                        <div className="title">{t(`hotel.widgets.searchBar.popularSearchText`)} </div>
                        <div className="cities-buttons">
                            <div>
                                {cities.map((item: any, index: any) => {
                                    return (
                                        <Button
                                            key={index}
                                            variant="outlined"
                                            onMouseDown={() => {
                                                getSearch(item.label);
                                                setFilterData({
                                                    ...filterData,
                                                    location: item,
                                                });
                                                formik.setFieldValue('location', item);
                                                setTimeout(() => {
                                                    handleFocusOutFunc({
                                                        ...filterData,
                                                        location: item,
                                                    });
                                                });
                                            }}
                                        >
                                            {item.city !== '-' ? item.name : item.name}
                                        </Button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </Paper>
            </CustomListBox2Styled>
        );
    };

    const CustomList = (props: any, option: any) => {
        return (
            <CustomListStyled>
                <Box component="li" {...props}>
                    <span style={{ marginLeft: '10px' }}>{option.label}</span>
                    <span className="badge">
                        {option.referenceType === 1 ? <Hotel fontSize="small" /> : <LocationOn fontSize="small" />}
                    </span>
                </Box>
            </CustomListStyled>
        );
    };

    const PassengerCard = (props: any) => {
        const { filterDataTemp } = props;

        const [childArr, setChildArr] = useState<any>([]);
        const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
        const handleClick = (event: React.MouseEvent<any>) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClosePassengerCard = () => {
            setAnchorEl(null);
            props.onDataChange(passengerControl());
        };

        const openPassengerCard = Boolean(anchorEl);

        const [totalCount, setTotalCount] = useState<number>(filterDataTemp?.guestCount || 0);

        const [adultTotalCount, setAdultTotalCount] = useState<number>(filterDataTemp?.adultGuest || 0);

        const [passengerInfo, setPassengerInfo] = useState<any>([
            {
                count: filterDataTemp.adultGuest,
                name: t(`hotel.widgets.searchBar.passengerText.ADT`),
                desc: '(12-65)',
                code: 'ADT',
                arr: [],
            },
            {
                count: filterDataTemp.childArr.length || 0,
                name: t(`hotel.widgets.searchBar.passengerText.CHD`),
                desc: '(2-12)',
                code: 'CHD',
                arr: filterDataTemp.childArr,
            },
        ]);

        const decreasePassenger = (item: any, index: number) => {
            if (item.code === 'CHD') {
                if (Number(item.count) > 0) {
                    //Yetişkin ve yaşlı
                    if ((index === 0 || index === 3) && adultTotalCount === 1) {
                        return;
                        // setAdultTotalCount(adultTotalCount - 1);
                    }
                    if (index === 0 || index === 3) {
                        setAdultTotalCount(adultTotalCount - 1);
                    }
                    let tempArr = passengerInfo;
                    tempArr[index].count = Number(item.count) - 1;

                    tempArr[index].arr = childArr.slice(0, -1);
                    setTotalCount(totalCount - 1);
                    setPassengerInfo([...tempArr]);

                    setChildArr(tempArr[index].arr);
                }
            } else {
                if (item.count > 0) {
                    //Yetişkin ve yaşlı
                    if ((index === 0 || index === 3) && adultTotalCount === 1) {
                        return;
                        // setAdultTotalCount(adultTotalCount - 1);
                    }
                    if (index === 0 || index === 3) {
                        setAdultTotalCount(adultTotalCount - 1);
                    }
                    let tempArr = passengerInfo;
                    tempArr[index].count = item.count - 1;
                    setTotalCount(totalCount - 1);
                    setPassengerInfo([...tempArr]);
                }
            }
        };
        const increasePassenger = (item: any, index: number) => {
            if (item.code === 'CHD') {
                if (Number(item.count) < 3) {
                    let tempArr = passengerInfo;
                    tempArr[index].count = Number(item.count) + 1;

                    // tempArr[index].arr = childArr.slice(0, -1);

                    tempArr[index].arr.push('1');

                    setTotalCount(totalCount + 1);

                    if (index === 0 || index === 3) {
                        setAdultTotalCount(adultTotalCount + 1);
                    }
                    setPassengerInfo([...tempArr]);
                    setChildArr(tempArr[index].arr);

                    // totalCount + 1 > 9 && formik.setFieldError('passengerCount', 'test');
                }
            } else {
                if (Number(item.count) < 4) {
                    let tempArr = passengerInfo;
                    tempArr[index].count = Number(item.count) + 1;

                    setTotalCount(totalCount + 1);

                    if (index === 0 || index === 3) {
                        setAdultTotalCount(adultTotalCount + 1);
                    }
                    setPassengerInfo([...tempArr]);

                    // totalCount + 1 > 9 && formik.setFieldError('passengerCount', 'test');
                }
            }
        };

        const passengerControl = () => {
            const tempData = {
                adultCount: passengerInfo[0].count,
                childCount: passengerInfo[1].count,
                childArr: passengerInfo[1].arr,
                passengerCount: totalCount,
            };

            formik.setFieldValue('adultGuest', tempData.adultCount);
            formik.setFieldValue('childGuest', tempData.childCount);

            formik.setFieldValue('passengerCount', tempData.adultCount + tempData.childCount);
            return tempData;
        };

        const adultCountString = `${adultTotalCount} ${t('hotel.widgets.searchBar.passengerText.ADT')}${
            filterDataTemp?.childArr.length > 0
                ? ', ' + filterDataTemp?.childArr.length + ' ' + t('hotel.widgets.searchBar.passengerText.CHD')
                : ''
        }`;

        useEffect(() => {
            setAdultTotalCount(Number(filterDataTemp.adultGuest));
        }, [filterDataTemp.guestCount]);
        useEffect(() => {
            setChildArr(filterDataTemp?.childArr);
        }, [filterDataTemp.childArr]);

        return (
            <>
                <CustomInput
                    className="custom-input-passenger"
                    value={adultCountString}
                    type="text"
                    fullWidth
                    variant="filled"
                    label={t('hotel.widgets.searchBar.guestCount')}
                    InputProps={{
                        readOnly: true,
                        endAdornment: (
                            <InputAdornment position="end">
                                <Person color="primary" fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                    onClick={handleClick}
                    error={Boolean(formik.errors.guestCount)}
                />
                <Popover
                    open={openPassengerCard}
                    anchorEl={anchorEl}
                    onClose={handleClosePassengerCard}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    sx={{
                        mt: 1,
                    }}
                >
                    <PassengerCardStyled>
                        <Box className="passengerCard">
                            {passengerInfo.map((item: any, index: any) => {
                                return (
                                    <>
                                        <div className="passengerCardContent" key={index}>
                                            <div className="label">{item.name}</div>
                                            <div className="buttons">
                                                <IconButton
                                                    color="inherit"
                                                    onClick={() => {
                                                        decreasePassenger(item, index);
                                                    }}
                                                >
                                                    <RemoveCircle fontSize="medium" />
                                                </IconButton>
                                                <div className="count">{item.count}</div>
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => {
                                                        increasePassenger(item, index);
                                                    }}
                                                >
                                                    <AddCircle fontSize="medium" />
                                                </IconButton>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}

                            {childArr.length > 0 && (
                                <div className="age-area">
                                    {childArr?.map((item: any, index: any) => {
                                        return (
                                            <div key={index} className="child-age-content">
                                                <div className="title">
                                                    {t('hotel.widgets.searchBar.passengerText.childAge')}
                                                </div>
                                                <div className="age-select">
                                                    <CustomSelect
                                                        key={childArr.length}
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 200,
                                                                },
                                                            },
                                                        }}
                                                        defaultValue={String(
                                                            Math.min(
                                                                Math.max(isNaN(Number(item)) ? 0 : Number(item), 1),
                                                                17
                                                            )
                                                        )}
                                                        className="time-select"
                                                        fullWidth
                                                        label={t(
                                                            'hotel.widgets.searchBar.passengerText.chooseAge'
                                                        ).toString()}
                                                        variant="outlined"
                                                        options={dates}
                                                        size="small"
                                                        onChange={(e: any) => {
                                                            const tempArr = childArr;
                                                            tempArr[index] = e.target.value;
                                                            return tempArr;
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}
                                    <Typography color={'error'} fontSize={'11px'} mt={1}>
                                        {t('hotel.widgets.searchBar.passengerText.childAgeInfo')}
                                    </Typography>
                                </div>
                            )}
                        </Box>
                    </PassengerCardStyled>
                </Popover>
            </>
        );
    };

    const handleAutocompleteChange1 = (event: any, value: any) => {
        setFilterData({
            ...filterData,
            location: value,
        });
        setTimeout(() => {
            handleFocusOutFunc({
                ...filterData,
                location: value,
            });
        });
    };

    const handleDataPassenger = (data: any) => {
        setFilterData({
            ...filterData,
            adultGuest: data.adultCount,

            guestCount: data.passengerCount,
            childArr: data.childArr,
        });
    };

    const validation = yup.object().shape({
        location: yup.object().shape({
            label: yup.string().required(`${t('yup.required')}`),
        }),

        checkInDate: yup
            .date()
            .required(`${t('yup.required')}`)
            .min(moment(new Date()).add('day', -1), 'Past'),
        checkOutDate: yup.date().required(`${t('yup.required')}`),
        passengerCount: yup.number().test({
            name: 'max',
            exclusive: false,
            params: {},
            message: t(`hotel.widgets.searchBar.passengerText.countInfo`).toString(),
            test: function (value, data) {
                const CountAdtSrc = data.parent.adultCount;

                if (typeof value === 'undefined') {
                    return true;
                }
                if (data.parent.infantCount > CountAdtSrc) {
                    return false;
                }
                return value <= 7 ? true : false;
            },
        }),
    });
    const formik = useFormik<filterDataInterface>({
        initialValues: {
            location: {
                label: '',
                referenceId: undefined,
                name: '',
                city: '',
                district: '',
                rating: undefined,
                country: '',
                referenceType: undefined,
                starNumber: undefined,
                type: '',
            },
            checkInDate: '',
            checkOutDate: '',
            guestCount: 0,

            adultGuest: 2,
            childArr: [],
        },

        onSubmit: async () => {
            sendSearch();
        },
        // validationSchema: validation,
        validationSchema: validation,
    });

    const fetchCallBack = useCallback(async () => {
        setFromData([]);
        setFilterData({ ...filterData });
        if (data) {
            await getSearchCode(data.location.referenceId);
        }
    }, [data]);

    const handleClickSubmit = (event: any) => {
        event.preventDefault();

        formik.handleSubmit();
    };

    const [defaultCalendarMonth, setDefaultCalendarMonth] = useState<any>();
    const handleCompareDates = (departureDate: any, selectedDate: any) => {
        const currentDate = dayjs();
        const maxSelectableDate = currentDate.add(365, 'day');
        const selected = dayjs(selectedDate);

        if (departureDate) {
            const minSelectableDate = dayjs(departureDate);
            return selected.isBefore(minSelectableDate) || selected.isAfter(maxSelectableDate);
        }

        return selected.isAfter(maxSelectableDate);
    };
    const popularCodes = ['94080', '30240', '94752', '23968', '94304', '10048', '68768', '103376', '6354656'];
    const getCities = useCallback(async (text: any) => {
        try {
            const response = await searchPopularCities(text);

            const data = response.data.hits.hits ? response.data.hits.hits : [];

            const popularDataList = data
                .map((item: any) => ({
                    label: item._source.Name,
                    referenceId: item._source.ReferenceID,
                    name: item._source.Name,
                    city: item._source.City,
                    district: item._source.District,
                    rating: item._source.Rating,
                    country: 'Türkiye',
                    referenceType: item._source.ReferenceType,
                    starNumber: item._source.StarNumber,
                    type: item._source.Type,
                }))
                .filter((tempData: any) => {
                    return popularCodes.includes(String(tempData.referenceId)) && tempData.type === '-';
                })
                .sort(
                    (a: any, b: any) =>
                        popularCodes.indexOf(String(a.referenceId)) - popularCodes.indexOf(String(b.referenceId))
                );

            setCities(popularDataList);
        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        formik.setFieldValue('location', filterData.location);

        formik.setFieldValue('checkInDate', filterData.checkInDate);
        formik.setFieldValue('checkOutDate', filterData.checkOutDate);
    }, [filterData, setFilterData]);
    useEffect(() => {
        fetchCallBack();
    }, [i18n.language]);

    return (
        <PageStyled>
            {!showDetail && (
                <Grid container spacing={showDetail ? 0 : 1}>
                    <form onSubmit={handleClickSubmit} className={`form-area ${!showDetail ? 'bg-color' : ''}`}>
                        <Grid className="custom-grid" item container spacing={0.5}>
                            <Grid container flex={1} item spacing={0.5}>
                                <Grid container xs={12} sm={12} md={4} spacing={0.5} item>
                                    <Grid sx={{ position: 'relative' }} xs={12} sm={12} md item>
                                        <Autocomplete
                                            value={filterData.location.label}
                                            popupIcon={
                                                <InputAdornment position="end">
                                                    <LocationOn style={{ fontSize: 20 }} color="primary" />
                                                </InputAdornment>
                                            }
                                            options={fromData}
                                            filterOptions={(x) => x}
                                            sx={{
                                                [`& .${autocompleteClasses.popupIndicator}`]: {
                                                    transform: 'none',
                                                },
                                            }}
                                            onOpen={() => {
                                                cities.length === 0 && getCities(popularCodes);
                                            }}
                                            // freeSolo={false}
                                            autoSelect={true}
                                            PaperComponent={(e: any) => {
                                                let tempReturn: any;
                                                fromData.length !== 0
                                                    ? (tempReturn = CustomListBox(e))
                                                    : (tempReturn = CustomListBox2());

                                                return tempReturn;
                                            }}
                                            onChange={handleAutocompleteChange1}
                                            key={focusIndex}
                                            open={focusIndex === 1 ? true : undefined}
                                            // onInputChange={(e, value) => {
                                            //     setFilterData({
                                            //         ...filterData,
                                            //         from: value,
                                            //     });
                                            // }}
                                            renderInput={(params) => (
                                                <CustomInput
                                                    {...params}
                                                    type="text"
                                                    fullWidth
                                                    variant="filled"
                                                    onChange={(e: any) => {
                                                        getSearch(e.target.value);
                                                    }}
                                                    onBlur={() => {
                                                        setFocusIndex(0);
                                                    }}
                                                    autoFocus={focusIndex === 1 ? true : undefined}
                                                    // onFocus={(e) => {
                                                    //     getSearch(
                                                    //         'start',
                                                    //         e.target.value
                                                    //     );
                                                    // }}
                                                    label={t('hotel.widgets.searchBar.location')}
                                                    error={
                                                        formik.touched.location?.label &&
                                                        Boolean(formik.errors.location?.label)
                                                    }
                                                />
                                            )}
                                            // getOptionLabel={(option: any) =>
                                            //     `${option.code} - ${option.city}, ${option.country}`
                                            // }
                                            // filterOptions={createFilterOptions({
                                            //     stringify: (option) => option.label,
                                            // })}
                                            renderOption={CustomList}
                                            disableClearable={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container xs={12} sm={12} md={8} spacing={0.5} item>
                                    <Grid container xs={12} sm={12} md spacing={0.5} item>
                                        <Grid xs={6} sm={6} md item>
                                            <CustomDatePicker
                                                specialDates={true}
                                                disablePast
                                                // views={['day', 'date']}
                                                // selectedSection={'day'}
                                                shouldDisableDate={(e: any) =>
                                                    handleCompareDates(moment(new Date()).format('YYYY-MM-DD'), e)
                                                }
                                                value={filterData.checkInDate ? dayjs(filterData.checkInDate) : null}
                                                error={formik.touched.checkInDate && !!formik.errors.checkInDate}
                                                onClose={() => {
                                                    if (media.width <= 1024) {
                                                        if (filterData.checkInDate === '') {
                                                            setFilterData({
                                                                ...filterData,
                                                                checkInDate: moment(new Date()).format('YYYY-MM-DD'),
                                                            });
                                                            setTimeout(() => {
                                                                handleFocusOutFunc({
                                                                    ...filterData,
                                                                    checkInDate: moment(new Date()).format(
                                                                        'YYYY-MM-DD'
                                                                    ),
                                                                });
                                                            });
                                                        }
                                                    }
                                                }}
                                                // maxDate={dayjs(formik.values.returnDate)}
                                                name="checkInDate"
                                                variant="filled"
                                                label={t('hotel.widgets.searchBar.checkInDate')}
                                                onChange={(e: any) => {
                                                    if (!isNaN(e.$D)) {
                                                        if (
                                                            filterData.checkOutDate !== '' &&
                                                            dayjs(filterData.checkOutDate) < dayjs(e.$d)
                                                        ) {
                                                            setFilterData({
                                                                ...filterData,
                                                                checkInDate: moment(e.$d).format('YYYY-MM-DD'),
                                                                checkOutDate: moment(e.$d)
                                                                    .add(1, 'days')
                                                                    .format('YYYY-MM-DD'),
                                                            });
                                                            formik.setFieldValue('checkOutDate', null);
                                                        } else {
                                                            setFilterData({
                                                                ...filterData,
                                                                checkInDate: moment(e.$d).format('YYYY-MM-DD'),
                                                            });
                                                        }

                                                        formik.setFieldValue(
                                                            'checkInDate',
                                                            moment(e.$d).format('YYYY-MM-DD')
                                                        );

                                                        setDefaultCalendarMonth(
                                                            dayjs(moment(e.$d).format('YYYY-MM-DD'))
                                                        );
                                                        setTimeout(() => {
                                                            handleFocusOutFunc({
                                                                ...filterData,
                                                                checkInDate: moment(e.$d).format('YYYY-MM-DD'),
                                                            });
                                                        });
                                                    }
                                                }}
                                                key={focusIndex}
                                                open={focusIndex === 2 ? true : undefined}
                                                // onClose={() => {
                                                //     setFocusIndex(0);
                                                // }}
                                                renderInput={(params: any) => (
                                                    <CustomInput
                                                        {...params}
                                                        type="text"
                                                        fullWidth
                                                        variant="filled"
                                                        onChange={(e: any) => {
                                                            getSearch(e.target.value);
                                                        }}
                                                        autoFocus={focusIndex === 2 ? true : undefined}
                                                        // onFocus={(e) => {
                                                        //     getSearch(
                                                        //         'end',
                                                        //         e.target.value
                                                        //     );
                                                        // }}
                                                        label={t('hotel.widgets.searchBar.checkInDate')}
                                                        // error={true}
                                                        error={
                                                            formik.touched.checkInDate && !!formik.errors.checkInDate
                                                        }
                                                        helperText={
                                                            formik.touched.checkInDate && formik.errors.checkInDate
                                                        }
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid xs={6} sm={6} md item className={`relative-isOneWay`}>
                                            <CustomDatePicker
                                                specialDates={true}
                                                // defaultCalendarMonth={'3'}
                                                // views={['day', 'month']}
                                                // selectedSections={'day'}
                                                defaultCalendarMonth={defaultCalendarMonth}
                                                shouldDisableDate={(e: any) =>
                                                    handleCompareDates(formik.values.checkInDate, e)
                                                }
                                                minDate={dayjs(formik.values.checkInDate)}
                                                className={`ghostDatePicker-control`}
                                                value={filterData.checkOutDate ? dayjs(filterData.checkOutDate) : null}
                                                open={focusIndex === 3 ? true : undefined}
                                                error={formik.touched.checkOutDate && !!formik.errors.checkOutDate}
                                                key={formik.values.checkInDate + '-' + focusIndex}
                                                name="checkOutDate"
                                                variant="filled"
                                                label={t('hotel.widgets.searchBar.checkOutDate')}
                                                onChange={(e: any) => {
                                                    if (!isNaN(e.$D)) {
                                                        setFilterData({
                                                            ...filterData,
                                                            checkOutDate: moment(e.$d).format('YYYY-MM-DD'),
                                                        });

                                                        setTimeout(() => {
                                                            handleFocusOutFunc({
                                                                ...filterData,
                                                                checkOutDate: moment(e.$d).format('YYYY-MM-DD'),
                                                            });
                                                        });
                                                    }
                                                }}
                                                today={false}
                                                // slots={{
                                                //     day: {
                                                //         selectedDay: dayjs('2023-11-17'),
                                                //         hoveredDay: dayjs('2023-11-17'),
                                                //     } as any,
                                                // }}

                                                onClose={() => {
                                                    if (media.width <= 1024) {
                                                        if (filterData.checkOutDate === '') {
                                                            setFilterData({
                                                                ...filterData,
                                                                checkOutDate: moment(new Date()).format('YYYY-MM-DD'),
                                                            });
                                                            setTimeout(() => {
                                                                handleFocusOutFunc({
                                                                    ...filterData,
                                                                    checkOutDate: moment(new Date()).format(
                                                                        'YYYY-MM-DD'
                                                                    ),
                                                                });
                                                            });
                                                        }
                                                    }
                                                }}
                                                // onClose={() => {
                                                //     setFocusIndex(0);
                                                // }}
                                                renderInput={(params: any) => (
                                                    <CustomInput
                                                        {...params}
                                                        type="text"
                                                        fullWidth
                                                        variant="filled"
                                                        onChange={(e: any) => {
                                                            getSearch(e.target.value);
                                                        }}
                                                        autoFocus={focusIndex === 3 ? true : undefined}
                                                        // onFocus={(e) => {
                                                        //     getSearch(
                                                        //         'end',
                                                        //         e.target.value
                                                        //     );
                                                        // }}
                                                        label={t('hotel.widgets.searchBar.checkOutDate')}
                                                        // error={true}
                                                        error={
                                                            formik.touched.checkOutDate && !!formik.errors.checkOutDate
                                                        }
                                                        helperText={
                                                            formik.touched.checkOutDate && formik.errors.checkOutDate
                                                        }
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid xs={12} sm={12} md={'auto'} item>
                                        <PassengerCard onDataChange={handleDataPassenger} filterDataTemp={filterData} />
                                    </Grid>
                                </Grid>
                                {/* buraya kadar input gridler */}
                            </Grid>
                            <Grid item>
                                <Button
                                    fullWidth
                                    className="search-button"
                                    sx={{
                                        height: '56px',
                                        fontSize: 14,
                                        gap: 1,
                                    }}
                                    variant="contained"
                                    size="large"
                                    color="secondary"
                                    // onClick={sendSearch}
                                    id={`gtm-${gtm}-search-button`}
                                    type="submit"
                                >
                                    {media.width <= 900
                                        ? showDetail
                                            ? t('hotel.widgets.searchBar.button.searchAgainButton')
                                            : t('hotel.widgets.searchBar.button.searchHotel')
                                        : ''}

                                    <Search />
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            )}
            {showDetail && !isMobil && (
                <Grid container spacing={showDetail ? 0 : 1}>
                    <form onSubmit={handleClickSubmit} className="form-area">
                        <Grid className="custom-grid" item container spacing={0.75}>
                            <Grid container flex={1} item spacing={0.75}>
                                <Grid container xs={12} sm={12} md={4} spacing={0.75} item>
                                    <Grid sx={{ position: 'relative' }} xs={12} sm={12} md item>
                                        <Autocomplete
                                            value={filterData.location.label}
                                            popupIcon={
                                                <InputAdornment position="end">
                                                    <LocationOn style={{ fontSize: 20 }} color="primary" />
                                                </InputAdornment>
                                            }
                                            options={fromData}
                                            filterOptions={(x) => x}
                                            sx={{
                                                [`& .${autocompleteClasses.popupIndicator}`]: {
                                                    transform: 'none',
                                                },
                                            }}
                                            onOpen={() => {
                                                cities.length === 0 && getCities(popularCodes);
                                            }}
                                            autoSelect={true}
                                            PaperComponent={(e: any) => {
                                                let tempReturn: any;
                                                fromData.length !== 0
                                                    ? (tempReturn = CustomListBox(e))
                                                    : (tempReturn = CustomListBox2());

                                                return tempReturn;
                                            }}
                                            onChange={handleAutocompleteChange1}
                                            key={focusIndex}
                                            open={focusIndex === 1 ? true : undefined}
                                            // onInputChange={(e, value) => {
                                            //     setFilterData({
                                            //         ...filterData,
                                            //         from: value,
                                            //     });
                                            // }}
                                            renderInput={(params) => (
                                                <CustomInput
                                                    {...params}
                                                    type="text"
                                                    fullWidth
                                                    variant="filled"
                                                    onChange={(e: any) => {
                                                        getSearch(e.target.value);
                                                    }}
                                                    onBlur={() => {
                                                        setFocusIndex(0);
                                                    }}
                                                    autoFocus={focusIndex === 1 ? true : undefined}
                                                    // onFocus={(e) => {
                                                    //     getSearch(
                                                    //         'start',
                                                    //         e.target.value
                                                    //     );
                                                    // }}
                                                    label={t('hotel.widgets.searchBar.location')}
                                                    error={
                                                        formik.touched.location?.label &&
                                                        Boolean(formik.errors.location?.label)
                                                    }
                                                />
                                            )}
                                            // getOptionLabel={(option: any) =>
                                            //     `${option.code} - ${option.city}, ${option.country}`
                                            // }
                                            // filterOptions={createFilterOptions({
                                            //     stringify: (option) => option.label,
                                            // })}
                                            renderOption={CustomList}
                                            disableClearable={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container xs={12} sm={12} md={8} spacing={0.75} item>
                                    <Grid container xs={12} sm={12} md spacing={0.75} item>
                                        <Grid xs={6} sm={6} md item>
                                            <CustomDatePicker
                                                specialDates={true}
                                                disablePast
                                                // views={['day', 'date']}
                                                // selectedSection={'day'}
                                                shouldDisableDate={(e: any) =>
                                                    handleCompareDates(moment(new Date()).format('YYYY-MM-DD'), e)
                                                }
                                                value={filterData.checkInDate ? dayjs(filterData.checkInDate) : null}
                                                error={formik.touched.checkInDate && !!formik.errors.checkInDate}
                                                onClose={() => {
                                                    if (media.width <= 1024) {
                                                        if (filterData.checkInDate === '') {
                                                            setFilterData({
                                                                ...filterData,
                                                                checkInDate: moment(new Date()).format('YYYY-MM-DD'),
                                                            });
                                                            setTimeout(() => {
                                                                handleFocusOutFunc({
                                                                    ...filterData,
                                                                    checkInDate: moment(new Date()).format(
                                                                        'YYYY-MM-DD'
                                                                    ),
                                                                });
                                                            });
                                                        }
                                                    }
                                                }}
                                                // maxDate={dayjs(formik.values.returnDate)}
                                                name="checkInDate"
                                                variant="filled"
                                                label={t('hotel.widgets.searchBar.checkInDate')}
                                                onChange={(e: any) => {
                                                    if (!isNaN(e.$D)) {
                                                        if (
                                                            filterData.checkOutDate !== '' &&
                                                            dayjs(filterData.checkOutDate) < dayjs(e.$d)
                                                        ) {
                                                            setFilterData({
                                                                ...filterData,
                                                                checkInDate: moment(e.$d).format('YYYY-MM-DD'),
                                                                checkOutDate: moment(e.$d)
                                                                    .add(1, 'days')
                                                                    .format('YYYY-MM-DD'),
                                                            });
                                                        } else {
                                                            setFilterData({
                                                                ...filterData,
                                                                checkInDate: moment(e.$d).format('YYYY-MM-DD'),
                                                            });
                                                        }

                                                        formik.setFieldValue(
                                                            'checkInDate',
                                                            moment(e.$d).format('YYYY-MM-DD')
                                                        );

                                                        setDefaultCalendarMonth(
                                                            dayjs(moment(e.$d).format('YYYY-MM-DD'))
                                                        );
                                                        setTimeout(() => {
                                                            handleFocusOutFunc({
                                                                ...filterData,
                                                                checkInDate: moment(e.$d).format('YYYY-MM-DD'),
                                                            });
                                                        });
                                                    }
                                                }}
                                                key={focusIndex}
                                                open={focusIndex === 2 ? true : undefined}
                                                // onClose={() => {
                                                //     setFocusIndex(0);
                                                // }}
                                                renderInput={(params: any) => (
                                                    <CustomInput
                                                        {...params}
                                                        type="text"
                                                        fullWidth
                                                        variant="filled"
                                                        onChange={(e: any) => {
                                                            getSearch(e.target.value);
                                                        }}
                                                        autoFocus={focusIndex === 2 ? true : undefined}
                                                        // onFocus={(e) => {
                                                        //     getSearch(
                                                        //         'end',
                                                        //         e.target.value
                                                        //     );
                                                        // }}
                                                        label={t('hotel.widgets.searchBar.checkInDate')}
                                                        // error={true}
                                                        error={
                                                            formik.touched.checkInDate && !!formik.errors.checkInDate
                                                        }
                                                        helperText={
                                                            formik.touched.checkInDate && formik.errors.checkInDate
                                                        }
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid xs={6} sm={6} md item className={`relative-isOneWay`}>
                                            <CustomDatePicker
                                                specialDates={true}
                                                // defaultCalendarMonth={'3'}
                                                // views={['day', 'month']}
                                                // selectedSections={'day'}
                                                defaultCalendarMonth={defaultCalendarMonth}
                                                shouldDisableDate={(e: any) =>
                                                    handleCompareDates(formik.values.checkInDate, e)
                                                }
                                                minDate={dayjs(formik.values.checkInDate)}
                                                className={`ghostDatePicker-control`}
                                                value={filterData.checkOutDate ? dayjs(filterData.checkOutDate) : null}
                                                open={focusIndex === 3 ? true : undefined}
                                                error={formik.touched.checkOutDate && !!formik.errors.checkOutDate}
                                                key={formik.values.checkInDate + '-' + focusIndex}
                                                name="checkOutDate"
                                                variant="filled"
                                                label={t('hotel.widgets.searchBar.checkOutDate')}
                                                onChange={(e: any) => {
                                                    if (!isNaN(e.$D)) {
                                                        setFilterData({
                                                            ...filterData,
                                                            checkOutDate: moment(e.$d).format('YYYY-MM-DD'),
                                                        });

                                                        setTimeout(() => {
                                                            handleFocusOutFunc({
                                                                ...filterData,
                                                                checkOutDate: moment(e.$d).format('YYYY-MM-DD'),
                                                            });
                                                        });
                                                    }
                                                }}
                                                today={false}
                                                // slots={{
                                                //     day: {
                                                //         selectedDay: dayjs('2023-11-17'),
                                                //         hoveredDay: dayjs('2023-11-17'),
                                                //     } as any,
                                                // }}

                                                onClose={() => {
                                                    if (media.width <= 1024) {
                                                        if (filterData.checkOutDate === '') {
                                                            setFilterData({
                                                                ...filterData,
                                                                checkOutDate: moment(new Date()).format('YYYY-MM-DD'),
                                                            });
                                                            setTimeout(() => {
                                                                handleFocusOutFunc({
                                                                    ...filterData,
                                                                    checkOutDate: moment(new Date()).format(
                                                                        'YYYY-MM-DD'
                                                                    ),
                                                                });
                                                            });
                                                        }
                                                    }
                                                }}
                                                // onClose={() => {
                                                //     setFocusIndex(0);
                                                // }}
                                                renderInput={(params: any) => (
                                                    <CustomInput
                                                        {...params}
                                                        type="text"
                                                        fullWidth
                                                        variant="filled"
                                                        onChange={(e: any) => {
                                                            getSearch(e.target.value);
                                                        }}
                                                        autoFocus={focusIndex === 3 ? true : undefined}
                                                        // onFocus={(e) => {
                                                        //     getSearch(
                                                        //         'end',
                                                        //         e.target.value
                                                        //     );
                                                        // }}
                                                        label={t('hotel.widgets.searchBar.checkOutDate')}
                                                        // error={true}
                                                        error={
                                                            formik.touched.checkOutDate && !!formik.errors.checkOutDate
                                                        }
                                                        helperText={
                                                            formik.touched.checkOutDate && formik.errors.checkOutDate
                                                        }
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid xs={12} sm={12} md={'auto'} item>
                                        <PassengerCard onDataChange={handleDataPassenger} filterDataTemp={filterData} />
                                    </Grid>
                                </Grid>
                                {/* buraya kadar input gridler */}
                            </Grid>
                            <Grid item>
                                <Button
                                    fullWidth
                                    className="search-button"
                                    sx={{
                                        height: '56px',
                                        fontSize: 14,
                                        gap: 1,
                                    }}
                                    variant="contained"
                                    size="large"
                                    color="secondary"
                                    // onClick={sendSearch}
                                    id={`gtm-${gtm}-search-button`}
                                    type="submit"
                                >
                                    {media.width <= 900
                                        ? showDetail
                                            ? t('hotel.widgets.searchBar.button.searchAgainButton')
                                            : t('hotel.widgets.searchBar.button.searchHotel')
                                        : ''}

                                    <Search />
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            )}
            <>
                {showDetail && isMobil && (
                    <div className="box">
                        <div className="head">
                            <div className="top">
                                <div className="from-to">
                                    <CalendarToday color="primary" className="icon" />
                                    <span>
                                        {moment(data.checkInDate).locale(i18n.language).format('DD MMM ddd')} -{' '}
                                        {moment(data.checkOutDate).locale(i18n.language).format('DD MMM ddd')}
                                    </span>
                                </div>
                                <div className="buttons">
                                    <Button
                                        startIcon={<Icon color="primary">edit</Icon>}
                                        className="edit"
                                        size="small"
                                        onClick={() => setDrawer('searchbar')}
                                    >
                                        {t('hotel.widgets.searchBar.button.change')}
                                    </Button>
                                </div>
                            </div>
                            <div className="bottom" id="scrollControl">
                                <div className="trip-info">
                                    <div className="box">
                                        <div className="head">
                                            <div className="left">
                                                <div className="from-to">
                                                    <Person color="primary" className="icon" />
                                                    <span>{data.adultGuest}</span>
                                                    <Divider
                                                        className="divider"
                                                        orientation="vertical"
                                                        variant="middle"
                                                        flexItem
                                                    />
                                                </div>
                                                {data.childArr.length > 0 && (
                                                    <div className="from-to">
                                                        <ChildCare color="primary" className="icon" />
                                                        <span>{data.childArr.length}</span>
                                                        <Divider
                                                            className="divider"
                                                            orientation="vertical"
                                                            variant="middle"
                                                            flexItem
                                                        />
                                                    </div>
                                                )}

                                                <div className="from-to">
                                                    <NightlightRound color="primary" className="icon" />
                                                    <span>
                                                        {moment(data.checkOutDate).diff(
                                                            moment(data.checkInDate),
                                                            'days'
                                                        )}{' '}
                                                    </span>
                                                    <Divider
                                                        className="divider"
                                                        orientation="vertical"
                                                        variant="middle"
                                                        flexItem
                                                    />
                                                </div>
                                                <div className="from-to">
                                                    <LocationOn color="primary" className="icon" />

                                                    <div>
                                                        {searchName &&
                                                            searchName +
                                                                ' ' +
                                                                t('hotel.widgets.searchBar.label.hotels')}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <SwipeableDrawer
                            anchor={'bottom'}
                            open={drawer === 'searchbar'}
                            onClose={() => setDrawer('')}
                            onOpen={() => setDrawer('searchbar')}
                            disableSwipeToOpen={false}
                            PaperProps={{
                                style: {
                                    borderTopLeftRadius: 12,
                                    borderTopRightRadius: 12,
                                    maxHeight: 'calc(100% - 50px)',
                                },
                            }}
                        >
                            <SearchBarWidgetDrawerStyled>
                                <div className="title">
                                    {t('hotel.widgets.searchBar.button.searchAgainButton')}
                                    <IconButton onClick={() => setDrawer('')} className="close">
                                        <Cancel fontSize="inherit" />
                                    </IconButton>
                                </div>
                                <form onSubmit={handleClickSubmit} className="form-area">
                                    <Grid className="custom-grid" item container spacing={1}>
                                        <Grid container flex={1} item spacing={1}>
                                            <Grid container xs={12} sm={12} md spacing={1} item>
                                                <Grid sx={{ position: 'relative' }} xs={12} sm={12} md={6} item>
                                                    <Autocomplete
                                                        value={filterData.location.label}
                                                        popupIcon={
                                                            <InputAdornment position="end">
                                                                <LocationOn style={{ fontSize: 20 }} color="primary" />
                                                            </InputAdornment>
                                                        }
                                                        options={fromData}
                                                        filterOptions={(x) => x}
                                                        sx={{
                                                            [`& .${autocompleteClasses.popupIndicator}`]: {
                                                                transform: 'none',
                                                            },
                                                        }}
                                                        onOpen={() => {
                                                            cities.length === 0 && getCities(popularCodes);
                                                        }}
                                                        autoSelect={true}
                                                        PaperComponent={(e: any) => {
                                                            let tempReturn: any;
                                                            fromData.length !== 0
                                                                ? (tempReturn = CustomListBox(e))
                                                                : (tempReturn = CustomListBox2());

                                                            return tempReturn;
                                                        }}
                                                        onChange={handleAutocompleteChange1}
                                                        key={focusIndex}
                                                        open={focusIndex === 1 ? true : undefined}
                                                        // onInputChange={(e, value) => {
                                                        //     setFilterData({
                                                        //         ...filterData,
                                                        //         from: value,
                                                        //     });
                                                        // }}
                                                        renderInput={(params) => (
                                                            <CustomInput
                                                                {...params}
                                                                type="text"
                                                                fullWidth
                                                                variant="filled"
                                                                onChange={(e: any) => {
                                                                    getSearch(e.target.value);
                                                                }}
                                                                onBlur={() => {
                                                                    setFocusIndex(0);
                                                                }}
                                                                autoFocus={focusIndex === 1 ? true : undefined}
                                                                // onFocus={(e) => {
                                                                //     getSearch(
                                                                //         'start',
                                                                //         e.target.value
                                                                //     );
                                                                // }}
                                                                label={t('hotel.widgets.searchBar.location')}
                                                                error={
                                                                    formik.touched.location?.label &&
                                                                    Boolean(formik.errors.location?.label)
                                                                }
                                                            />
                                                        )}
                                                        // getOptionLabel={(option: any) =>
                                                        //     `${option.code} - ${option.city}, ${option.country}`
                                                        // }
                                                        // filterOptions={createFilterOptions({
                                                        //     stringify: (option) => option.label,
                                                        // })}
                                                        renderOption={CustomList}
                                                        disableClearable={true}
                                                    />
                                                </Grid>
                                                <Grid sx={{ position: 'relative' }} xs={12} sm={12} md={6} item>
                                                    <CustomDatePicker
                                                        specialDates={true}
                                                        disablePast
                                                        // views={['day', 'date']}
                                                        // selectedSection={'day'}
                                                        shouldDisableDate={(e: any) =>
                                                            handleCompareDates(
                                                                moment(new Date()).format('YYYY-MM-DD'),
                                                                e
                                                            )
                                                        }
                                                        value={
                                                            filterData.checkInDate
                                                                ? dayjs(filterData.checkInDate)
                                                                : null
                                                        }
                                                        error={
                                                            formik.touched.checkInDate && !!formik.errors.checkInDate
                                                        }
                                                        onClose={() => {
                                                            if (media.width <= 1024) {
                                                                if (filterData.checkInDate === '') {
                                                                    setFilterData({
                                                                        ...filterData,
                                                                        checkInDate: moment(new Date()).format(
                                                                            'YYYY-MM-DD'
                                                                        ),
                                                                    });
                                                                    setTimeout(() => {
                                                                        handleFocusOutFunc({
                                                                            ...filterData,
                                                                            checkInDate: moment(new Date()).format(
                                                                                'YYYY-MM-DD'
                                                                            ),
                                                                        });
                                                                    });
                                                                }
                                                            }
                                                        }}
                                                        // maxDate={dayjs(formik.values.returnDate)}
                                                        name="checkInDate"
                                                        variant="filled"
                                                        label={t('hotel.widgets.searchBar.checkInDate')}
                                                        onChange={(e: any) => {
                                                            if (!isNaN(e.$D)) {
                                                                if (
                                                                    filterData.checkOutDate !== '' &&
                                                                    dayjs(filterData.checkOutDate) < dayjs(e.$d)
                                                                ) {
                                                                    setFilterData({
                                                                        ...filterData,
                                                                        checkInDate: moment(e.$d).format('YYYY-MM-DD'),
                                                                        checkOutDate: moment(e.$d)
                                                                            .add(1, 'days')
                                                                            .format('YYYY-MM-DD'),
                                                                    });
                                                                    formik.setFieldValue('checkOutDate', null);
                                                                } else {
                                                                    setFilterData({
                                                                        ...filterData,
                                                                        checkInDate: moment(e.$d).format('YYYY-MM-DD'),
                                                                    });
                                                                }

                                                                formik.setFieldValue(
                                                                    'checkInDate',
                                                                    moment(e.$d).format('YYYY-MM-DD')
                                                                );

                                                                setDefaultCalendarMonth(
                                                                    dayjs(moment(e.$d).format('YYYY-MM-DD'))
                                                                );
                                                                setTimeout(() => {
                                                                    handleFocusOutFunc({
                                                                        ...filterData,
                                                                        checkInDate: moment(e.$d).format('YYYY-MM-DD'),
                                                                    });
                                                                });
                                                            }
                                                        }}
                                                        key={focusIndex}
                                                        open={focusIndex === 3 ? true : undefined}
                                                        // onClose={() => {
                                                        //     setFocusIndex(0);
                                                        // }}
                                                        renderInput={(params: any) => (
                                                            <CustomInput
                                                                {...params}
                                                                type="text"
                                                                fullWidth
                                                                variant="filled"
                                                                onChange={(e: any) => {
                                                                    getSearch(e.target.value);
                                                                }}
                                                                autoFocus={focusIndex === 3 ? true : undefined}
                                                                // onFocus={(e) => {
                                                                //     getSearch(
                                                                //         'end',
                                                                //         e.target.value
                                                                //     );
                                                                // }}
                                                                label={t('hotel.widgets.searchBar.checkInDate')}
                                                                // error={true}
                                                                error={
                                                                    formik.touched.checkInDate &&
                                                                    !!formik.errors.checkInDate
                                                                }
                                                                helperText={
                                                                    formik.touched.checkInDate &&
                                                                    formik.errors.checkInDate
                                                                }
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid sx={{ position: 'relative' }} xs={12} sm={12} md={6} item>
                                                    <CustomDatePicker
                                                        specialDates={true}
                                                        // defaultCalendarMonth={'3'}
                                                        // views={['day', 'month']}
                                                        // selectedSections={'day'}
                                                        defaultCalendarMonth={defaultCalendarMonth}
                                                        shouldDisableDate={(e: any) =>
                                                            handleCompareDates(formik.values.checkInDate, e)
                                                        }
                                                        minDate={dayjs(formik.values.checkInDate)}
                                                        className={`ghostDatePicker-control`}
                                                        value={
                                                            filterData.checkOutDate
                                                                ? dayjs(filterData.checkOutDate)
                                                                : null
                                                        }
                                                        // open={
                                                        //     filterData.isOneWay === 2 &&
                                                        //     filterData.returnDate === ''
                                                        // }
                                                        error={
                                                            formik.touched.checkOutDate && !!formik.errors.checkOutDate
                                                        }
                                                        key={formik.values.checkInDate + '-' + focusIndex}
                                                        name="checkOutDate"
                                                        variant="filled"
                                                        label={t('hotel.widgets.searchBar.checkOutDate')}
                                                        onChange={(e: any) => {
                                                            if (!isNaN(e.$D)) {
                                                                setFilterData({
                                                                    ...filterData,
                                                                    checkOutDate: moment(e.$d).format('YYYY-MM-DD'),
                                                                });

                                                                setTimeout(() => {
                                                                    handleFocusOutFunc({
                                                                        ...filterData,
                                                                        checkOutDate: moment(e.$d).format('YYYY-MM-DD'),
                                                                    });
                                                                });
                                                            }
                                                        }}
                                                        today={false}
                                                        // slots={{
                                                        //     day: {
                                                        //         selectedDay: dayjs('2023-11-17'),
                                                        //         hoveredDay: dayjs('2023-11-17'),
                                                        //     } as any,
                                                        // }}

                                                        open={focusIndex === 4 ? true : undefined}
                                                        onClose={() => {
                                                            if (media.width <= 1024) {
                                                                if (filterData.checkOutDate === '') {
                                                                    setFilterData({
                                                                        ...filterData,
                                                                        checkOutDate: moment(new Date()).format(
                                                                            'YYYY-MM-DD'
                                                                        ),
                                                                    });
                                                                    setTimeout(() => {
                                                                        handleFocusOutFunc({
                                                                            ...filterData,
                                                                            checkOutDate: moment(new Date()).format(
                                                                                'YYYY-MM-DD'
                                                                            ),
                                                                        });
                                                                    });
                                                                }
                                                            }
                                                        }}
                                                        // onClose={() => {
                                                        //     setFocusIndex(0);
                                                        // }}
                                                        renderInput={(params: any) => (
                                                            <CustomInput
                                                                {...params}
                                                                type="text"
                                                                fullWidth
                                                                variant="filled"
                                                                onChange={(e: any) => {
                                                                    getSearch(e.target.value);
                                                                }}
                                                                autoFocus={focusIndex === 4 ? true : undefined}
                                                                // onFocus={(e) => {
                                                                //     getSearch(
                                                                //         'end',
                                                                //         e.target.value
                                                                //     );
                                                                // }}
                                                                label={t('hotel.widgets.searchBar.checkOutDate')}
                                                                // error={true}
                                                                error={
                                                                    formik.touched.checkOutDate &&
                                                                    !!formik.errors.checkOutDate
                                                                }
                                                                helperText={
                                                                    formik.touched.checkOutDate &&
                                                                    formik.errors.checkOutDate
                                                                }
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid sx={{ position: 'relative' }} xs={12} sm={12} md={6} item>
                                                    <PassengerCard
                                                        onDataChange={handleDataPassenger}
                                                        filterDataTemp={filterData}
                                                    />
                                                </Grid>
                                                <Grid
                                                    sx={{ position: 'relative', marginTop: '5px' }}
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    item
                                                >
                                                    <Button
                                                        fullWidth
                                                        className="search-button"
                                                        sx={{
                                                            height: '56px',
                                                            fontSize: 14,
                                                            gap: 1,
                                                        }}
                                                        variant="contained"
                                                        size="large"
                                                        color="secondary"
                                                        // onClick={sendSearch}
                                                        id={`gtm-${gtm}-search-button`}
                                                        type="submit"
                                                    >
                                                        {media.width <= 900
                                                            ? showDetail
                                                                ? t('hotel.widgets.searchBar.button.searchAgainButton')
                                                                : t('hotel.widgets.searchBar.button.searchHotel')
                                                            : ''}

                                                        <Search />
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </form>

                                {/* yeni yer üstte */}
                                {/* <Grid container spacing={showDetail ? 0 : 1}>
                                            <form onSubmit={handleClickSubmit} className="form-area">
                                                <Grid className="custom-grid" item container>
                                                    <Grid item container xs={12} sm={12} md={12}>
                                                        <Autocomplete
                                                            // value={filterData.from.label}
                                                            popupIcon={
                                                                <InputAdornment position="end">
                                                                    <LocationOn style={{ fontSize: 20 }} color="primary" />
                                                                </InputAdornment>
                                                            }
                                                            options={fromData}
                                                            filterOptions={(x) => x}
                                                            sx={{
                                                                [`& .${autocompleteClasses.popupIndicator}`]: {
                                                                    transform: 'none',
                                                                },
                                                            }}
                                                            autoSelect={true}
                                                            // paper component acılacak son aranan yerler

                                                            // PaperComponent={(e: any) => {
                                                            //     let tempReturn: any;
                                                            //     fromData.length !== 0
                                                            //         ? (tempReturn = CustomListBox(e))
                                                            //         : (tempReturn = CustomListBox2('start'));

                                                            //     return tempReturn;
                                                            // }}
                                                            onChange={handleAutocompleteChange1}
                                                            key={focusIndex}
                                                            open={focusIndex === 1 ? true : undefined}
                                                            // onInputChange={(e, value) => {
                                                            //     setFilterData({
                                                            //         ...filterData,
                                                            //         from: value,
                                                            //     });
                                                            // }}
                                                            renderInput={(params) => (
                                                                <CustomInput
                                                                    {...params}
                                                                    type="text"
                                                                    fullWidth
                                                                    variant="filled"
                                                                    onChange={(e: any) => {
                                                                        console.log('e', e);

                                                                        //getSearch('start', e.target.value);
                                                                    }}
                                                                    onBlur={() => {
                                                                        setFocusIndex(0);
                                                                    }}
                                                                    autoFocus={focusIndex === 1 ? true : undefined}
                                                                    // onFocus={(e) => {
                                                                    //     getSearch(
                                                                    //         'start',
                                                                    //         e.target.value
                                                                    //     );
                                                                    // }}
                                                                    label={t('hotel.widgets.searchBar.location')}
                                                                    error={
                                                                        formik.touched.location?.label &&
                                                                        Boolean(formik.errors.location?.label)
                                                                    }
                                                                />
                                                            )}
                                                            // getOptionLabel={(option: any) =>
                                                            //     `${option.code} - ${option.city}, ${option.country}`
                                                            // }
                                                            // filterOptions={createFilterOptions({
                                                            //     stringify: (option) => option.label,
                                                            // })}
                                                            renderOption={CustomList}
                                                            disableClearable={true}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </Grid> */}
                            </SearchBarWidgetDrawerStyled>
                        </SwipeableDrawer>
                    </div>
                )}
            </>
        </PageStyled>
    );
};

export default HotelSearchBar;
